
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title bg-warning">Warning </h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body" style="padding: 0.4rem; margin-left: 10px">During import of DART deal {{dartDeal}} below solutions which are mapped to Base + Actual (BA) billing model require at least one SAPSKUs with BA billing model, DART CLASS as "supply" with valid net price.</div>
    <div class="modal-body" *ngIf="supplies" style="padding: 0.4rem; margin-left: 10px">Solutions which are missing supplies SKUs: {{supplies}}</div>
    <div class="modal-body" *ngIf="netPrice" style="padding: 0.4rem; margin-left: 10px">Solutions which are missing Net Price: {{netPrice}}</div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="continueImport()">Continue to Import</button>
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
    </div>
  </div>
</div>